import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATES } from "@/lib/states";

export function Field({ label, id, ...props }) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-zinc-300">{label}</Label>
      <Input id={id} data-testid={id} className="h-11 bg-zinc-950" {...props} />
    </div>
  );
}

export function StateSelect({ value, onChange, testId, label = "State" }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-zinc-300">{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className="h-11 bg-zinc-950"><SelectValue placeholder="Choose a state" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {STATES.map(([c, n]) => <SelectItem key={c} value={c}>{n}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
